import axios from "axios";

export function register(email, password) {
  const payload = {
    email,
    password,
  };

  return axios.post("/oauth/register", payload);
}

export function tokenAuthorize(code, codeVerifier, redirectUri, clientId) {
  const formData = new FormData();
  formData.set("grant_type", "authorization_code");
  // formData.set("client_code", clientCode);
  formData.set("client_id", clientId);
  formData.set("code_verifier", codeVerifier);
  formData.set("redirect_uri", redirectUri);
  formData.set("code", code);

  return axios.post("/oauth/token", formData);
}

// not used atm
export function refreshAccessToken(refreshToken) {
  const formData = new FormData();
  formData.set("grant_type", "refresh_token");
  formData.set("client_id", import.meta.env.VITE_OAUTH2_CLIENT_ID);
  formData.set("refresh_token", refreshToken);

  return axios.post("/oauth/token", formData);
}

export function clearTokens() {
  const backendHost = import.meta.env.VITE_BACKEND_HOST;
  const redirectUri = import.meta.env.VITE_BASE_URL + "/login";
  const clientId = import.meta.env.VITE_OAUTH2_CLIENT_ID;

  const queryParams = new URLSearchParams({
    client_id: clientId,
    redirect_uri: redirectUri,
  });

  window.location.href = `${backendHost}/api/v1/oauth/logout?${queryParams}`;
}
